import React from "react";
import heroImg from "../../assets/images/home/aboutUsSectionLeft.webp";
import Button from "../../components/button/Button";
import { ROUTES_NAME } from "../../constants/routes";
import { useNavigate } from "react-router-dom";
import Bach from "../../components/bach/Bach";

const AboutUsSection = () => {
  const navigate = useNavigate();

  return (
    <section className="bg-primary-50 md:pt-16 pt-8 px-4 md:px-12">
      <div className="max-w-7xl mx-auto flex flex-col-reverse md:flex-row gap-10">
        {/* Left Image */}
        <div className="md:w-1/2 flex justify-center">
          <img
            src={heroImg}
            alt="about us"
            loading="lazy"
            decoding="async"
            className="max-w-xs md:max-w-md object-contain"
          />
        </div>

        {/* Right Content */}
        <div className="md:w-1/2 md:pb-20">
          <Bach>Go Digital With Us!</Bach>

          <h2 className="text-2xl md:text-3xl mb-4">
            About Us
            <span className="flex items-center gap-1 mt-1">
              <span className="w-10 h-[2px] bg-gray-400"></span>
              <span className="w-2 h-[2px] bg-gray-400"></span>
              <span className="w-6 h-[2px] bg-gray-400"></span>
            </span>
          </h2>

          <h3 className="text-2xl md:text-3xl mb-6 font-outfitRegular">
            Your{" "}
            <span className="text-black font-outfitSemiBold">
              All-in-One Platform
            </span>{" "}
            for Real Exam Experience &{" "}
            <span className="text-black font-outfitSemiBold">
              Smart Coaching Tech
            </span>
          </h3>

          <p className="text-base leading-relaxed mb-6 font-outfitRegular">
            Edupro Hub helps coaching institutes{" "}
            <strong> across India deliver full-scale CBT mock exams</strong>{" "}
            that feel just like the real thing. From{" "}
            <strong>exam center bookings, admit card generation,</strong> and{" "}
            <strong>document verification</strong>, to{" "}
            <strong>Strict invigilation</strong> and{" "}
            <strong>instant results</strong>— we simulate the actual exam
            environment to bridge the gap between preparation and performance.
            <br />
            <br />
            With <strong> built-in LMS, ERP tools</strong>, and{" "}
            <strong> custom mobile apps</strong>,Edupro Hub also makes it easy
            to manage batches, fees, content, and student progress—all from one
            powerful dashboard.
          </p>

          <Button
            onClick={() => navigate(ROUTES_NAME.ABOUT)}
            variant="secondary"
          >
            Know More
          </Button>
        </div>
      </div>
    </section>
  );
};

export default AboutUsSection;
